import "./ClubLogo.css";

const LOGO_URL = "/perninhas-logo-transparent.png";

export function ClubLogo({ size = "small", className = "" }) {
  return <img className={`club-logo club-logo-${size} ${className}`.trim()} src={LOGO_URL} alt="Escudo Pelada dos Perninhas FC 2026" data-testid={`club-logo-${size}`} />;
}
